module.exports = __webpack_public_path__ + "img/RB_Rapier.13de7461.png";